var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"os-url-main"},[_c('Divider',[_vm._v("LightPicture")]),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"os-main"},[_c('div',{staticClass:"os-item"},[_c('span',{staticClass:"osuu-net geek-github"}),_c('p',[_vm._v("github")])]),_c('div',{staticClass:"os-item"},[_c('span',{staticClass:"osuu-net geek-gitee2"}),_c('p',[_vm._v("gitee")])])])
}]

export { render, staticRenderFns }